import { withPrefix } from "gatsby";

const pathPrefix = withPrefix("/");

const countryMap = new Map([
  ["/en_IE/", "hoover.ie"],
  ["/it_IT/", "hoover.it"],
  ["/fr_FR/", "hoover.fr"],
  ["/cs_CZ/", "hoover.cz"],
  ["/sk_SK/", "hoover.sk"],
  ["/es_ES/", "hoover.es"],
  ["/de_DE/", "hoover.de"],
  ["/nl_NL/", "hoover.nl"],
  ["/tr_TR/", "hoover.com.tr"],
  ["/en_GB/", "hoover.co.uk"],
  ["/fr_BE/", "hoover.be"],
  ["/nl_BE/", "hoover.be"],
  ["/it_CH/", "hoover.ch"],
  ["/fr_CH/", "hoover.ch"],
  ["/de_CH/", "hoover.ch"],
  ["/pt_PT/", "hoover.pt"],
  ["/pl_PL/", "hoover.pl"],
  ["/el_GR/", "hoover.gr"],
  ["/sv_SE/", "hoover.se"],
  ["/fi_FI/", "hoover.fi"],
  ["/da_DK/", "hoover.dk"],
  ["/hu_HU/", "hoover.hu"],
  ["/hr_HR/", "hoover.hr"],
  ["/ro_RO/", "hoover.ro"],
  ["/sr_RS_latin/", "hoover.rs"],
  ["/sl_SI/", "hoover.si"],
  ["/no_NO/", "hoover-norge.no"],
  ["/fr_MA/", "hoover.ma"],
  ["/uk_UA/", "hoover.ua"],
  ["/ru_RU/", "hoover.ru"],
  ["/lt_LT/", "hoover-baltics.com"],
]);

const addUtm = (url) => {
  const urlObj = new URL(url);
  urlObj.searchParams.append("utm_source", countryMap.get(pathPrefix));
  urlObj.searchParams.append("utm_medium", "referral");
  urlObj.searchParams.append("utm_campaign", "always_on_brand_website");
  return urlObj.toString();
};

export default addUtm;
